import React from 'react';
import { motion } from 'framer-motion';
export function WhyDidntWorkSection() {
  const items = ['Ruido blanco', 'Música relajante', 'Respiraciones sueltas', 'Videos de YouTube', 'Tapones', 'Dormir con la televisión', 'Ignorarlo a la fuerza'];
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0B1224] border-y border-[#15203B]" data-id="element-352">
      <div className="max-w-4xl mx-auto" data-id="element-353">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-354">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-355">
            Por qué lo que has intentado no funcionó
          </h2>
          <p className="text-xl text-gray-400" data-id="element-356">Quizá ya probaste:</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-357">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="bg-[#070B16] p-5 rounded-xl border border-[#15203B] flex items-center gap-4" data-id="element-358">
              <div className="text-red-400 font-bold text-xl flex-shrink-0" data-id="element-359">
                ✕
              </div>
              <p className="text-gray-300 font-medium" data-id="element-360">{item}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center max-w-2xl mx-auto space-y-4 text-lg text-gray-300" data-id="element-361">
          <p data-id="element-362">Y tal vez algo ayudó un poco. Pero no resolvió el patrón.</p>
          <p data-id="element-363">Porque la mayoría de soluciones intentan tapar el sonido.</p>
          <p className="text-white font-medium text-xl mt-6" data-id="element-364">
            El Protocolo Silencio TTPM™ trabaja diferente. No busca taparlo.
            Busca cambiar la relación de tu cerebro con él.
          </p>
        </motion.div>
      </div>
    </section>;
}